import { createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/img/close.png'


const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "infomodal-cover" }, null, -1)
const _hoisted_2 = { class: "infomodal-wrapper" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "title" }, "兑换奖品的联系方式", -1)
const _hoisted_5 = { class: "input-item" }
const _hoisted_6 = /*#__PURE__*/_createVNode("label", null, "姓名", -1)
const _hoisted_7 = { class: "input-item" }
const _hoisted_8 = /*#__PURE__*/_createVNode("label", null, "联系电话", -1)
const _hoisted_9 = { class: "input-item" }
const _hoisted_10 = /*#__PURE__*/_createVNode("label", null, "收货地址", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: "close",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeClick && _ctx.closeClick(...args)))
      }, [
        _hoisted_3
      ]),
      _hoisted_4,
      _createVNode("div", _hoisted_5, [
        _hoisted_6,
        _withDirectives(_createVNode("input", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.name = $event)),
          type: "text"
        }, null, 512), [
          [_vModelText, _ctx.name]
        ])
      ]),
      _createVNode("div", _hoisted_7, [
        _hoisted_8,
        _withDirectives(_createVNode("input", {
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.phone = $event)),
          type: "text"
        }, null, 512), [
          [_vModelText, _ctx.phone]
        ])
      ]),
      _createVNode("div", _hoisted_9, [
        _hoisted_10,
        _withDirectives(_createVNode("textarea", {
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.address = $event))
        }, null, 512), [
          [_vModelText, _ctx.address]
        ])
      ]),
      _createVNode("button", {
        class: "btn",
        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.submitClick && _ctx.submitClick(...args)))
      }, "提交")
    ])
  ], 64))
}